import {Route} from "react-router-dom";
import UrlsConfig from "@/config/UrlsConfig";
import {lazy} from "react";

const ReferenceBookDocumentTypes = lazy(() => import("@/pages/ReferenceBooks/Lists/DocumentSigning/DocumentTypes/ReferenceBookDocumentTypes"));
const LaboratoryLegalEntities = lazy(() => import("@/pages/ReferenceBooks/Lists/DocumentSigning/LaboratoryLegalEntities/LaboratoryLegalEntities"));
const ReferenceBookDocumentStatuses = lazy(() => import("@/pages/ReferenceBooks/Lists/DocumentSigning/DocumentStatuses/ReferenceBookDocumentStatuses"));
const ReferenceBookErrors = lazy(() => import("@/pages/ReferenceBooks/Lists/DocumentSigning/Errors/ReferenceBookErrors"));

const urlsConfig = new UrlsConfig();

export function referenceBookDocumentSigningRoutes() {
    return (
      <>
          <Route path={urlsConfig.referenceBookDocumentTypes.to} element={<ReferenceBookDocumentTypes/>}/>
          <Route path={urlsConfig.referenceBookLaboratoryLegalEntities.to} element={<LaboratoryLegalEntities/>}/>
          <Route path={urlsConfig.referenceBookDocumentStatuses.to} element={<ReferenceBookDocumentStatuses/>}/>
          <Route path={urlsConfig.referenceBookErrors.to} element={<ReferenceBookErrors/>}/>
      </>
    );
}
